import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class BeniSmartCompsetAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketServiceWithHotel: HotelAndMarketServiceWithHotel;

  // @ts-expect-error: Property 'buildURL' in type 'BeniSmartCompsetAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot,
    requestType: string,
    query: Record<string, unknown>,
  ) {
    // This is for calling `.save()` on the record.
    // By default, Ember Data will call `/benchmarkinsight/smart_compset/?subscription_id=smart_compset` for updating the record.
    // We want to call `/benchmarkinsight/smart_compset/?subscription_id=:id` instead, so we need to overwrite the URL here.
    if (requestType === 'updateRecord') {
      const hotelId = this.hotelAndMarketServiceWithHotel.hotel.id;
      return `${this.host}/${this.namespace}/benchmarkinsight/smart_compset/?subscription_id=${hotelId}`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 5.
    return super.buildURL(modelName, id, snapshot, requestType, query);
  }

  pathForType(modelName: string): string {
    // This is for calling `queryRecord` with `typeKey: 'benchmarkinsight/smart_compset'`
    // By default, Ember Data will pluralise the key and call `/benchmarkinsight/smart_compsets`.
    // We want to call `/benchmarkinsight/smart_compset` instead, so we need to overwrite the path here.
    return modelName;
  }
}
